import { Divider } from '@mui/material';
import { contactButtons, VoiceContactStatus } from '@nice-ccf/core-sdk';
import {
  CcfContactControlPanel,
  CcfVoicemailPopover,
  ContactControlPanelHeading,
  fetchAgentContactGroup,
  updateActiveContact,
  updateAppSpaceTab,
} from '@nice-ccf/ui-components';
import {
  CcfBox,
  CcfCallResloveIcon,
  CcfCallTransferIcon,
  CcfCard,
  CcfDeleteVoiceMailIcon,
  CcfOutboundAssignmentIcon,
  CcfOutboundwithPhoneIcon,
  CcfTooltip,
  CcfTypography,
  CcfUpArrowIcon,
  CcfVoiceMailIcon,
} from '@nice-ccf/ui-controls';
import { useDispatch } from 'react-redux';
import CcfContactPanelMediaControl from '../ccf-contact-control-panel/ccf-contact-panel-media-control';
import { Contact } from '../model/contact';
import styles from './ccf-voicemail-control-panel.module.scss';
import { dispositionInteractionActions } from '@nice-ccf/ui-components';
import { useState } from 'react';
import { AppSpace } from '../../../enums/app-space-tabs';
/* eslint-disable-next-line */
export interface CcfVoicemailControlPanelProps {
  contact: Contact;
  outBoundCallinitiated: boolean;
}

/**
 * Function to handle dialog close
 * @param e - React.SyntheticEvent
 * @example handleDialogClose(e)
 */
export function CcfVoicemailControlPanel(props: CcfVoicemailControlPanelProps) {
  const controls: any = props?.contact?.contactButtons;
  const dispatch = useDispatch();
  const { setDispositionResolution } = dispositionInteractionActions;
  const [hideMediaControl, setHideMediaControl] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showPopover, setShowPopover] = useState(false);
  const [popoverFeature, setPopoverFeature] = useState('');

  const contactButtonsArr: any = [
    contactButtons.hold,
    contactButtons.transfer,
    contactButtons.mute,
    contactButtons.mask,
    contactButtons.record,
    contactButtons.keypad,
  ];
  /**
   * Function to dipatch RTA status for contact
   * @example dispatchContactRTAState()
   */
  const hideMediaControlClicked = () => {
    setHideMediaControl(!hideMediaControl);
  };

  /**
   * @example handleClose()
   */
  const handleClose = () => {
    setAnchorEl(null);
    setShowPopover(false);
  };

  const dialPadIcons = new Map([
    [
      'outBoundCall',
      <CcfOutboundwithPhoneIcon
        className={styles.custumIcon}
        viewBox="0 0 20 20"
      ></CcfOutboundwithPhoneIcon>,
    ],
    [
      'transfer',
      <CcfCallTransferIcon
        viewBox="0 0 25 20"
        className={styles.custumIcon}
      ></CcfCallTransferIcon>,
    ],
    [
      'commitment',
      <CcfOutboundAssignmentIcon
        className={styles.custumIcon}
        viewBox="0 0 20 20"
      ></CcfOutboundAssignmentIcon>,
    ],
  ]);

  /**
   *
   * @param control - contactButtons
   * @param event -React.MouseEvent
   * @example -   controlClicked('Consult', event)
   */
  const controlClicked = (control: contactButtons, event: any) => {
    switch (control) {
      case contactButtons.transfer:
        event.stopPropagation();
        dispatch(updateAppSpaceTab({ tab: AppSpace.DIRECTORY }));
        dispatch(fetchAgentContactGroup('my_team'));
        //setupForConsult();

        break;
      case contactButtons.hungup:
        console.log('hungup');
        dispatch(
          updateActiveContact({
            id: props.contact.id || '',
            updates: { contactStatus: VoiceContactStatus.DISCONNECTED },
          })
        );
        break;
      case contactButtons.outBoundCall:
        setAnchorEl(event.currentTarget);
        setPopoverFeature('outBoundCall');
        setShowPopover(true);
        break;
      case contactButtons.commitment:
        setAnchorEl(event.currentTarget);
        setPopoverFeature('commitment');
        setShowPopover(true);
        break;
      default:
        console.log(control + 'is clicked');
        break;
    }
  };

  /**
   * Function gets called on click of mark as resloved button
   * @param event - React.MouseEvent
   * @example  markAsRelovedClicked (event)
   */
  const markAsRelovedClicked = (event: React.MouseEvent) => {
    dispatch(
      setDispositionResolution({
        contactId: props.contact.id,
        isResolved: true,
      })
    );
  };

  return (
    <>
      <CcfCard className={styles.controlPanel} square={true}>
        {!props?.outBoundCallinitiated ? (
          <>
            <ContactControlPanelHeading
              headerText={`${[
                props?.contact?.customer?.firstName,
                props?.contact?.customer?.middleName,
                props?.contact?.customer?.lastName,
              ]
                .filter(Boolean)
                .join(' ')}`}
              headerTextClassess={'controlButtonHeaderText'}
              contact={props.contact}
            />

            <div className={styles.subheadingBlockForVoiceMail}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '5px',
                }}
              >
                {hideMediaControl && (
                  <CcfVoiceMailIcon
                    style={{
                      fill: '#007AB8',
                      width: '16px',
                      height: '16px',
                      marginRight: '10px',
                    }}
                  />
                )}
                <CcfTypography
                  variant="inherit"
                  className={styles.subHeading1ForVoiceMail}
                >
                  {props?.contact?.messageType}
                </CcfTypography>

                <Divider
                  style={{
                    backgroundColor: '#F0F0F0',
                    width: '1px',
                    height: '10px',
                    marginLeft: '5px',
                  }}
                />
                <CcfTypography className={styles.custServiceTxtForVoiceMail}>
                  Cust Service
                </CcfTypography>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <CcfTypography className={styles.dateTextForVoiceMail}>
                  April 14, 2022 at 4:34pm
                </CcfTypography>

                <CcfUpArrowIcon onClick={hideMediaControlClicked} />
              </div>
            </div>
            {!hideMediaControl && !props.outBoundCallinitiated && (
              <div style={{ transition: '0.3s ease-in' }}>
                <CcfContactPanelMediaControl
                  outBoundInitiatedStatus={props.outBoundCallinitiated}
                />
                <Divider
                  style={{
                    marginTop: '5px',
                    backgroundColor: '#F0F0F0',
                    width: '95%',
                    height: '1px',
                    marginLeft: '5px',
                  }}
                />
                <CcfBox id="ContactControlPanel" className={styles.buttonsGrid}>
                  {controls.map((item: contactButtons) => (
                    <CcfTooltip title={item} arrow>
                      <div
                        className={styles.digitalPanelButton}
                        onClick={(e: React.MouseEvent) =>
                          controlClicked(item, e)
                        }
                        id={`voicemail_${item}_icon`}
                      >
                        {dialPadIcons.get(item)}
                      </div>
                    </CcfTooltip>
                  ))}
                </CcfBox>
                <Divider
                  style={{
                    marginTop: '5px',
                    backgroundColor: '#F0F0F0',
                    width: '95%',
                    height: '1px',
                    marginLeft: '5px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  id={`${
                    props.outBoundCallinitiated ? 'HungUpIcon' : 'DeleteIcon'
                  }`}
                  className={styles.footerContainer}
                >
                  <CcfTooltip
                    title={props.outBoundCallinitiated ? 'HungUp' : 'Delete'}
                    arrow
                  >
                    <div
                      className="digitalPanelButton hungUp"
                      onClick={(e) => controlClicked(contactButtons.hungup, e)}
                      id="agent_voicemail_deleteIcon"
                    >
                      <CcfDeleteVoiceMailIcon
                        className="dailpadOpacity"
                        viewBox="0 0 20 20"
                        style={{ fill: '#007AB8' }}
                      ></CcfDeleteVoiceMailIcon>
                    </div>
                  </CcfTooltip>
                  <Divider
                    orientation="vertical"
                    variant="fullWidth"
                    className={styles.verticalDivider}
                  />

                  <CcfTooltip title={'Mark As Resolved'} arrow>
                    <div
                      id="agent_voicemail_markAsResolvedIcon"
                      className={styles.markAsResolved}
                      onClick={(e: React.MouseEvent<HTMLElement>) =>
                        markAsRelovedClicked(e)
                      }
                    >
                      <CcfCallResloveIcon
                        className={styles.resolvedIcon}
                        viewBox="0 0 22 22"
                      ></CcfCallResloveIcon>
                    </div>
                  </CcfTooltip>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <CcfContactControlPanel
              iconArr={contactButtonsArr}
              showHeader={true}
              showSubHeading={true}
              headerText={`${[
                props?.contact?.customer?.firstName,
                props?.contact?.customer?.middleName,
                props?.contact?.customer?.lastName,
              ]
                .filter(Boolean)
                .join(' ')}`}
              subHeading1={props.contact.customer.phoneNo}
              subHeading2="#439-Z3FM-5S23+Cust. Service Request"
              contact={props.contact}
            ></CcfContactControlPanel>
            <CcfBox
              className={props.outBoundCallinitiated ? styles.custumSpacer : ''}
            ></CcfBox>
            <ContactControlPanelHeading
              headerText={`${[
                props?.contact?.customer?.firstName,
                props?.contact?.customer?.middleName,
                props?.contact?.customer?.lastName,
              ]
                .filter(Boolean)
                .join(' ')}`}
              headerTextClassess={'controlButtonHeaderText'}
              contact={props.contact}
            />

            <div className={styles.subheadingBlockForVoiceMail}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '5px',
                }}
              >
                <CcfVoiceMailIcon
                  style={{
                    fill: '#007AB8',
                    width: '16px',
                    height: '16px',
                    marginRight: '10px',
                  }}
                />
                <CcfTypography
                  variant="inherit"
                  className={styles.subHeading1ForVoiceMail}
                >
                  {props?.contact?.messageType}
                </CcfTypography>

                <Divider
                  style={{
                    backgroundColor: '#F0F0F0',
                    width: '1px',
                    height: '10px',
                    marginLeft: '5px',
                  }}
                />
                <CcfTypography className={styles.custServiceTxtForVoiceMail}>
                  Cust Service
                </CcfTypography>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <CcfTypography className={styles.dateTextForVoiceMail}>
                  April 14, 2022 at 4:34pm
                </CcfTypography>

                <CcfUpArrowIcon onClick={hideMediaControlClicked} />
              </div>
            </div>
            {!hideMediaControl && (
              <div>
                <CcfContactPanelMediaControl
                  outBoundInitiatedStatus={props.outBoundCallinitiated}
                />

                <Divider
                  style={{
                    marginTop: '5px',
                    backgroundColor: '#F0F0F0',
                    width: '95%',
                    height: '1px',
                    marginLeft: '5px',
                    marginBottom: '10px',
                  }}
                />
                <div className={styles.footerContainer}>
                  <CcfTooltip
                    title={props.outBoundCallinitiated ? 'HungUp' : 'Delete'}
                    arrow
                  >
                    <div
                      className="digitalPanelButton hungUp"
                      onClick={(e) => controlClicked(contactButtons.hungup, e)}
                      style={{
                        cursor: props.outBoundCallinitiated
                          ? 'not-allowed'
                          : 'pointer',
                      }}
                    >
                      <CcfDeleteVoiceMailIcon
                        className="dailpadOpacity"
                        viewBox="0 0 20 20"
                        style={{
                          fill: props.outBoundCallinitiated
                            ? '#D2D8DB'
                            : '#007AB8',
                        }}
                      ></CcfDeleteVoiceMailIcon>
                    </div>
                  </CcfTooltip>
                  <Divider
                    orientation="vertical"
                    variant="fullWidth"
                    className={styles.verticalDivider}
                  />

                  <CcfTooltip title={'Mark As Resolved'} arrow>
                    <div
                      className={styles.markAsResolved}
                      onClick={(e: React.MouseEvent<HTMLElement>) =>
                        markAsRelovedClicked(e)
                      }
                      style={{
                        cursor: props.outBoundCallinitiated
                          ? 'not-allowed'
                          : 'pointer',
                      }}
                    >
                      <CcfCallResloveIcon
                        className={styles.resolvedIcon}
                        style={{
                          fill: props.outBoundCallinitiated
                            ? '#D2D8DB'
                            : '#2179c1',
                          cursor: props.outBoundCallinitiated
                            ? 'not-allowed'
                            : 'pointer',
                        }}
                        viewBox="0 0 22 22"
                      ></CcfCallResloveIcon>
                    </div>
                  </CcfTooltip>
                </div>
              </div>
            )}
          </>
        )}
      </CcfCard>
      {showPopover && (
        <CcfVoicemailPopover
          anchorEl={anchorEl}
          currentContact={props.contact}
          handleClose={handleClose}
          hideMediaControlClicked={hideMediaControlClicked}
          popoverFeature={popoverFeature}
        />
      )}
    </>
  );
}

export default CcfVoicemailControlPanel;
